/**
 * Pause registry for the automatic (timer) ads.
 * Any screen that must not be interrupted registers a reason while it runs:
 * a game round in progress, a Pi payment, an ad already on screen.
 * The scheduler only fires when no reason is registered.
 */
const reasons = new Set<string>();

const autoAds = {
  pause(reason: string) {
    reasons.add(reason);
  },
  resume(reason: string) {
    reasons.delete(reason);
  },
  isPaused(): boolean {
    return reasons.size > 0;
  },
  /** Timestamp of the last automatic ad, shared across pages and reloads. */
  STORAGE_KEY: "lastAutoAdTime",
};

export default autoAds;
